import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { BREAKPOINTS } from "context/media/MediaConstant";

// eslint-disable-next-line import/prefer-default-export
export const StyledOuterContainer = styled.div`
  width: "auto";
  min-height: 370px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: ${DIGIPOSTHEME.colors.white};

  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
    min-height: 350px;
  }
`;

export const StyledIconText = styled.div`
  height: 32px;

  margin: 8px 18px 8px;

  font-family: "Campton";
  font-size: 24px;
  line-height: 1.33;
  text-align: center;
  color: ${DIGIPOSTHEME.colors.secondaryGraySecondary};

  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
    margin: 8px 0px 20px;

    font-size: 18px;
  }
`;

export const StyledInfoText = styled.div`
  height: 48px;

  margin: 8px 0 0;

  font-family: "Campton";
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
  color: ${DIGIPOSTHEME.colors.secondaryGraySecondary};

  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
    margin: 8px 0px 20px;

    font-size: 14px;
  }
`;
